import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../../../SkeletonContainer';

/** Skeleton placeholder for form field (label + control). */
const FormFieldSkeleton = () => (
  <Box css={{ display: 'flex', flexDirection: 'column', gap: 'xs', marginBottom: 'default' }}>
    <Bone type="line" css={{ width: '40%', height: '14px' }} />
    <Bone type="line" css={{ width: '100%', height: '40px' }} />
  </Box>
);

/** Skeleton for the financial expectations and pet policy sections while criteria are loading. */
export default function RenterScreeningCriteriaModalSkeleton() {
  return (
    <SkeletonContainer>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
        <Box>
          <Box css={{ marginBottom: 'tight' }}>
            <Bone type="line" css={{ width: '70%', height: '20px' }} />
          </Box>
          <Bone type="line" css={{ width: '100%', marginBottom: 'default' }} />
          <Bone type="line" css={{ width: '90%', marginBottom: 'default' }} />
          <FormFieldSkeleton />
          <Box css={{ display: 'flex', alignItems: 'center', gap: 'tight', marginBottom: 'default' }}>
            <Bone type="line" css={{ width: '24px', height: '24px' }} />
            <Bone type="line" css={{ width: '55%', height: '14px' }} />
          </Box>
          <FormFieldSkeleton />
          <FormFieldSkeleton />
          <Box css={{ display: 'flex', alignItems: 'center', gap: 'tight', marginBottom: 'default' }}>
            <Bone type="line" css={{ width: '24px', height: '24px' }} />
            <Bone type="line" css={{ width: '45%', height: '14px' }} />
          </Box>
          <Bone type="line" css={{ width: '60%', height: '14px' }} />
        </Box>

        <Box>
          <Box css={{ marginBottom: 'tight' }}>
            <Bone type="line" css={{ width: '55%', height: '20px' }} />
          </Box>
          <Bone type="line" css={{ width: '100%', marginBottom: 'default' }} />
          <Bone type="line" css={{ width: '30%', height: '14px', marginBottom: 'tight' }} />
          <Box css={{ display: 'flex', gap: 'tight', marginBottom: 'default' }}>
            <Bone type="line" css={{ width: '48px', height: '36px' }} />
            <Bone type="line" css={{ width: '48px', height: '36px' }} />
          </Box>
          <Bone type="line" css={{ width: '95%', marginBottom: 'default' }} />
        </Box>
      </Box>
    </SkeletonContainer>
  );
}
